export default function maTimeOfDayInput() {
    return {
        restrict: 'E',
        scope: {
            values: '&',
            field: '&'
        },
        link: function(scope) {
            var hour = scope.values()[scope.field().name() + '.hour'];
            var minute = scope.values()[scope.field().name() + '.minute'];
            scope.value = hour + ':' + (minute < 10 ? '0' + minute : minute);
        },
        template: `<input type="time" ng-model="value"
            id="{{ name }}" name="{{ name }}" class="form-control"
            ng-required="v.required" />`
    };
}

maTimeOfDayInput.$inject = [];



// WEBPACK FOOTER //
// ./js/types/maTimeOfDayInputField.js